export function BooleanConstraints() {
  return (
    <div className='flex flex-col gap-4 p-4'>
      <div className='flex flex-col gap-1'>
        <h4 className='text-sm font-semibold text-neutral-950'>Boolean constraints</h4>
        <p className='text-xs text-neutral-600'>Boolean fields don't require additional configuration.</p>
      </div>
    </div>
  );
}
